// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__WJfet","actionsCol":"EnrolledClinics_actionsCol__3G1A0"};